import {AbstractListItemsLoader, Action, BaseListItem, OnListItemsListener} from "./types";
import {getMemberAuth} from "./auth";
import {PageFragment, PageFragmentProps, PageFragmentState} from "./PageFragment";
import {DownloadOutlined, PrintOutlined, RefreshOutlined} from "@mui/icons-material";
import {BaseApp} from "./BaseApp";

export enum ListToolbarButtonType {
  REFRESH = "refresh",
  DOWNLOAD = "download",
  PRINT = "print",
}

export abstract class BaseListFragment<T extends BaseListItem | string, L extends AbstractListItemsLoader<T>, P extends PageFragmentProps = PageFragmentProps, S extends PageFragmentState = PageFragmentState> extends PageFragment<P, S>
  implements OnListItemsListener<T> {

  protected readonly memberAuth = getMemberAuth();

  constructor(props: P, context: any, protected loader?: L) {
    super(props, context);
    this.loader = loader;
  }

  createToolbarActions(): Action[] {
    const actions: Action[] = [];
    const types = this.getListToolbarButtonTypes();
    if (types.includes(ListToolbarButtonType.REFRESH)) {
      actions.push(new Action("Refresh", () => this.reload(true).then(() => BaseApp.CONTEXT.showToast("Data refreshed.")), RefreshOutlined));
    }
    if (types.includes(ListToolbarButtonType.DOWNLOAD)) {
      actions.push(new Action("Download", () => this.doDownload(), DownloadOutlined));
    }
    if (types.includes(ListToolbarButtonType.PRINT)) {
      actions.push(new Action("Print", () => this.doPrint(), PrintOutlined));
    }
    return actions;
  }

  protected async doDownload(): Promise<void> {
  }

  protected async doPrint(): Promise<void> {
  }

  protected getListToolbarButtonTypes(): ListToolbarButtonType[] {
    return [];
  }

  setLoader(loader: L) {
    this.loader?.unregisterObserver(this);
    this.loader = loader;
    this.loader?.registerObserver(this);
    this.reload(true);
  }

  componentDidMount() {
    super.componentDidMount();
    this.loader?.registerObserver(this);
  }

  componentWillUnmount() {
    this.loader?.unregisterObserver(this);
  }

  onItemChanged(item: T) {
    this.forceUpdate();
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<void> {
    await this.loader?.loadListItems();
  }
}